import "./ServiceAreas.module.css";
import Header from "@/reusable_sections/Header";
import OurCanberraServiceMap from "./sections/OurCanberraServiceMap";
import ReleaseRoadmap from "./sections/ReleaseRoadmap";
import Footer from "@/reusable_sections/Footer";
export default function ServiceAreasPage() {
  return <div>
      <Header />
      <OurCanberraServiceMap />
      <ReleaseRoadmap />
      <Footer />
    </div>;
}